/**
* DevExpress Dashboard (_multi-query-data-source-wizard.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_wizard_1 = require("@devexpress/analytics-core/analytics-wizard");
var _utils_1 = require("../../../data/_utils");
var _data_source_wizard_model_1 = require("../models/_data-source-wizard-model");
var choose_data_source_type_page_1 = require("../pages/choose-data-source-type-page");
var choose_olap_connection_string_page_1 = require("../pages/choose-olap-connection-string-page");
var _choose_json_schema_page_1 = require("../pages/_choose-json-schema-page");
var _create_query_page_1 = require("../pages/_create-query-page");
var _parameters_item_provider_1 = require("../pages/_parameters-item-provider");
var _data_source_wizard_page_iterator_1 = require("./_data-source-wizard-page-iterator");
var _edit_query_wizard_1 = require("./_edit-query-wizard");
var DashboardMultiQueryWizardIterator = (function (_super) {
    __extends(DashboardMultiQueryWizardIterator, _super);
    function DashboardMultiQueryWizardIterator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DashboardMultiQueryWizardIterator.prototype.getInitialPage = function () {
        return _super.prototype.getInitialPage.call(this);
    };
    DashboardMultiQueryWizardIterator.prototype.getConfigureQueryPage = function () {
        return analytics_wizard_1.SqlDataSourceWizardPageId.MultiQueryConfigurePage;
    };
    DashboardMultiQueryWizardIterator.prototype.getConfigureSqlParametersPage = function () {
        return analytics_wizard_1.SqlDataSourceWizardPageId.MultiQueryConfigureParametersPage;
    };
    return DashboardMultiQueryWizardIterator;
}(_data_source_wizard_page_iterator_1.DataSourceWizardPageIteratorBase));
exports.DashboardMultiQueryWizardIterator = DashboardMultiQueryWizardIterator;
var DashboardMultiQueryDataSourceWizard = (function (_super) {
    __extends(DashboardMultiQueryDataSourceWizard, _super);
    function DashboardMultiQueryDataSourceWizard(pageFactory) {
        var _this = _super.call(this, pageFactory) || this;
        _this._extendCssClass = 'dxrd-multiqueries-sqldatasource-wizard';
        _this.height(443);
        return _this;
    }
    return DashboardMultiQueryDataSourceWizard;
}(_edit_query_wizard_1.DashboardQueryWizard));
exports.DashboardMultiQueryDataSourceWizard = DashboardMultiQueryDataSourceWizard;
function createDashboardMultiQueryWizard(requestWrapper, parameters, disableCustomSql, allowCreateNewJsonConnection, wizardSettings, dashboardConnectionStrings) {
    var factory = new analytics_wizard_1.PageFactory();
    var wizardOptions = new _data_source_wizard_model_1.DashboardMultiQueryDataSourceWizardOptions();
    wizardOptions.callbacks = _create_query_page_1.createQueryPageCallback(requestWrapper, parameters, DashboardMultiQueryDataSourceWizard.customQueriesPreset);
    wizardOptions.disableCustomSql = disableCustomSql;
    wizardOptions.requestWrapper = requestWrapper;
    wizardOptions.wizardSettings.enableSqlDataSource = wizardSettings && _utils_1.type.isDefined(wizardSettings.enableSqlDataSource) ? wizardSettings.enableSqlDataSource : true;
    wizardOptions.wizardSettings.enableJsonDataSource = wizardSettings && _utils_1.type.isDefined(wizardSettings.enableJsonDataSource) ? wizardSettings.enableJsonDataSource : true;
    wizardOptions.wizardSettings.enableOlapDataSource = wizardSettings && _utils_1.type.isDefined(wizardSettings.enableOlapDataSource) ? wizardSettings.enableOlapDataSource : true;
    wizardOptions.wizardSettings.enableObjectDataSource = false;
    wizardOptions.allowCreateNewJsonConnection = allowCreateNewJsonConnection || false;
    wizardOptions.connectionStrings = dashboardConnectionStrings;
    choose_data_source_type_page_1._registerChooseDataSourceTypePage(factory, wizardOptions);
    analytics_wizard_1._registerChooseSqlConnectionPage(factory, dashboardConnectionStrings.sql);
    choose_olap_connection_string_page_1._registerOlapConnectionStringsPage(factory, dashboardConnectionStrings.olap);
    analytics_wizard_1._registerMultiQueryConfigurePage(factory, wizardOptions);
    analytics_wizard_1._registerMultiQueryConfigureParametersPage(factory, requestWrapper);
    analytics_wizard_1._registerChooseJsonConnectionPage(factory, wizardOptions);
    analytics_wizard_1._registerChooseJsonSourcePage(factory, requestWrapper, function () { return new _parameters_item_provider_1.ParametersItemProvider(parameters()); });
    _choose_json_schema_page_1._registerChooseJsonSchemaPage(factory, requestWrapper);
    analytics_wizard_1._registerChooseObjectDataSourceTypesPage(factory, wizardOptions);
    analytics_wizard_1._registerChooseObjectDataSourceDataMembersPage(factory, wizardOptions);
    analytics_wizard_1._registerConfigureObjectDataSourceParametersPage(factory, function () { return new _parameters_item_provider_1.ParametersItemProvider(parameters()); });
    var multiQueryConfigurePageMeta = factory.getMetadata(analytics_wizard_1.SqlDataSourceWizardPageId.MultiQueryConfigurePage);
    multiQueryConfigurePageMeta.canNext = function (page) { return page._hasParametersToEdit(); };
    return new DashboardMultiQueryDataSourceWizard(factory);
}
exports.createDashboardMultiQueryWizard = createDashboardMultiQueryWizard;
